import CurrentUA from '@ali/tbm-ua';
import Url from '@ali/tbm-url';
import { froms } from './froms';

/**
 * 获取渠道名，会根据UA和SQM信息修正最终采用的渠道。
 * 同时在特定容器里还有优先级的逻辑，内部渠道优先用Query上的from而不是UA的
 */
export function getFromName(UA = CurrentUA) {
  const urlQuery = Url().query;
  let fromName,
    // 子渠道生效白名单，即匹配主渠道但内部优先级更高的子渠道from
    insideFroms = [],
    // 非UA渠道生效白名单，即无视主渠道修正的from，仅在主渠道强制优先时可置空
    outsideFroms = [
      froms.hisensetv.name,
      froms.cmcc.name,
      froms.alimamatk.name,
    ];

  if (UA.isDY) {
    fromName = froms.tbmovie.name;
  }
  if (UA.isMVP) {
    fromName = froms.tpppro.name;
  }
  if (UA.isAP) {
    fromName = froms.alipay.name;
    // 支付宝影城小程序
    if (UA.isAPTheaterApp) {
      fromName = froms.mtheater.name;
    } else if (UA.isMovieShow) {
      fromName = froms.aparhat.name;
    }

    insideFroms = [froms.apkoubei.name, froms.yulebao.name];
  }
  if (UA.isTB) {
    fromName = froms.nearby.name;
    insideFroms = [froms.taojinbi.name, froms.tbguess.name, froms.yule.name];
  }
  if (UA.isWB) {
    fromName = froms.weibo.name;
  }
  if (UA.isWBApp) {
    fromName = froms.weiboapp.name;
  }
  if (UA.isKB) {
    fromName = froms.koubei.name;
  }
  if (UA.isDM) {
    fromName = froms.damai.name;
  }
  if (UA.isWXApp) {
    // 微信小程序渠道
    fromName = froms.wechat.name;

    const sqmSegments = (urlQuery.sqm || '').split('.');
    // 淘好票影城小程序
    if (sqmSegments[1] === 'wechatm') {
      fromName = froms.wechatm.name;
    }
    // 嘉凯影城
    if (sqmSegments[1] === 'jiakaim') {
      fromName = froms.jiakaim.name;
    }
    // 武商摩尔影城
    if (sqmSegments[1] === 'moerm') {
      fromName = froms.moerm.name;
    }
    // 贵州星空影城
    if (sqmSegments[1] === 'xingkongm') {
      fromName = froms.xingkongm.name;
    }

    // 财付通限制需要重置所有渠道
    outsideFroms = [];
  }
  if (UA.isXHSMiniProgram) {
    fromName = froms.xhsminiprogram.name;
  }
  if (UA.isYKApp) {
    fromName = froms.youku.name;
  }
  if (UA.isTT) {
    fromName = froms.toutiao.name;
  }
  if (UA.isDouYin) {
    fromName = froms.douyin.name;
  }
  if (UA.isBaiduApp) {
    fromName = froms.baiduApp.name;
  }
  if (UA.isIQiYiMiniProgram) {
    fromName = froms.iQiYiMiniProgram.name;
  }
  if (UA.isKSminiApp) {
    fromName = froms.kuaishou.name;
  }

  if (UA.isMSDY) {
    fromName = froms.msdy.name;
  }

  if (UA.isMSDM) {
    fromName = froms.msdm.name;
  }

  if (insideFroms.concat(outsideFroms).indexOf(urlQuery.from) !== -1) {
    fromName = urlQuery.from;
  }

  fromName = fromName || urlQuery.from || froms.def.name;

  return fromName;
}
